export default "/kiban/_next/static/images/manufacture-6b82e488a6cf372d46345803e0815c15.png";